import React from "react";
import ReactPlayer from 'react-player'
import { isIOS, isMobile } from "react-device-detect";

const PlayVideo = (props) => {
    if (!props.url) return null;
    return (
        <div className="banner-video">
            <ReactPlayer
                url={props.url}
                playing={true}
                controls={true}
                playsinline={true}
                muted={isMobile && isIOS}
                width='100%'
                height='100%'
                onEnded={() => props.onEnded && props.onEnded()}
            />
        </div>
    )
};

export default PlayVideo;
